import { Helmet } from "react-helmet";
import faviconLookup from "../../../../assets/img/LUFP_V1/favicon.ico";
import faviconScanandClaim from "../../../../assets/img/LUFP_V1/scan-claim-favicon.png";
import faviconOptimusClaims from "../../../../assets/img/Optimus-claims/Favicon.png";
import faviconDirectRefunds from "../../../../assets/img/Direct_refunds/favivon.png";
import faviconOnlineFinanceClaims from "../../../../assets/img/Online-finance-claims/favicon.png";

const HelmetBasedOnDomain = () => {
    const domainName = window.location.hostname;
    let favicon;
    let brandName;
    if (domainName === 'localhost' || domainName === 'dev.lookupfinance.co.uk' 
        || domainName === 'pre.lookupfinance.co.uk' || domainName === 'lookupfinance.co.uk') {
        favicon = faviconLookup;
        brandName = 'LookUp Finance';
    }else if(domainName === 'dev.scanandclaim.co.uk' 
        || domainName === 'pre.scanandclaim.co.uk' || domainName === 'scanandclaim.co.uk'){
        favicon = faviconScanandClaim;
        brandName = 'Scan & Claim';
    }else if(domainName === 'dev.optimus-claims.co.uk' 
        || domainName === 'pre.optimus-claims.co.uk' || domainName === 'optimus-claims.co.uk'){
            favicon = faviconOptimusClaims;
            brandName = 'Optimus Claims';
    }else if(domainName === 'dev.direct-refunds.co.uk' 
        || domainName === 'pre.direct-refunds.co.uk' || domainName === 'direct-refunds.co.uk'){
            favicon = faviconDirectRefunds;
            brandName = 'Direct Refunds';
    }else if(domainName === 'dev.onlinefinanceclaims.co.uk' 
        || domainName === 'pre.onlinefinanceclaims.co.uk' || domainName === 'onlinefinanceclaims.co.uk'){
            favicon = faviconOnlineFinanceClaims;
            brandName = 'Online Finance Claims';
    }
    else {
        favicon = faviconLookup;
        brandName ="LookUp Finance"
    }
    return (
        <Helmet>
            <link rel="icon" href={favicon} />
            <title>{brandName}</title>
        </Helmet>
    )
}

export default HelmetBasedOnDomain;